<template>
    <section class="gmp-section gmp-mb-l">
        <div class="photo-tout">
            <div class="gmp-banner gmp-overview-hero">
                <picture>
                    <img src="@/assets/img/bottom.png" alt="" class="gmp-no-grab gmp-banner__image">
                </picture>
            </div>

<!--            <div class="photo-tout__background photo-tout__background&#45;&#45;fat" >-->
<!--                <div class="h-c-page">-->
<!--                    <div class="h-c-grid"></div>-->
<!--                </div>-->
<!--            </div>-->

<!--            ..... -->
            <div class="photo-tout__content photo-tout__content--fat">
                <div class="h-c-page">
                    <div class="h-c-grid">

                        <div class="h-c-grid__col h-c-grid__col--10 h-c-grid__col-l--5 h-c-grid__col-xl--4 h-c-grid__col--offset-1 h-c-grid__col-l--offset-0 h-c-grid__col-xl--offset-1">
                            <h3 class="h-c-headline h-c-headline--one photo-tout__headline">
                                咨询产品功能.
                            </h3>
                            <p>
                                我们的工作人员将为您提供耐心和专业的订货和采购业务分析。
                            </p>
                            <a href="tel:13910825707" class="h-c-link">
                                现在联系
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
    export default {
        name: "HomePhotoTout"
    }
</script>

<style lang="less">




    
</style>